import Component from './Component';
import { swiffyslider } from 'swiffy-slider';
import { getSiteCode, getStoredBlogs } from "../lib/RecentBlogsHelper";

export default class RecentBlogViews extends Component {
  load() {

    console.log('RecentBlogViews');

    const expiryDays = 30;

    // get siteCode

    const siteCode = getSiteCode();
    const title = document.querySelector('h1').textContent.trim();
    // console.log('blog title:', title);
    const imageUrl = document.querySelectorAll('meta[property="og:image"]')[0]?.content;
    // console.log('blog image:', imageUrl);
    const pageUrl = window.location.pathname;
    // console.log('blog url:', pageUrl);
    // stored date (current date)
    // const currentDate = new Date().toJSON().slice(0, 10);
    const currentDate = new Date();
    const currentDate_ms = Date.parse(currentDate);
    // store the full string as miliseconds since epoch.
    // and as try toLocaleString().slice(0, 10) for readability



    // Declaring an object with properties
    const blogObject =
    {
      siteCode: siteCode,
      seenDate: `${currentDate_ms}`,
      seenDateHuman: `${currentDate}`,
      title: title,
      image: imageUrl,
      url: pageUrl
    };
    // console.log('blogObject:', blogObject);



    // Get from Storage
    // Remove expired
    // check current URL isn't in currentArray
    // add current blog data onto currentArray
    // sort currentArray by seenDate
    // Set to Storage


    // Get from Storage
    let recentBlogsArray = getStoredBlogs(siteCode);
    // console.log('recentBlogsArray YY:::', recentBlogsArray);

    // validate array
    if (isBlogsArrayValid(recentBlogsArray) === false) {
      recentBlogsArray = []; // empty array if BlogsArray invalid
    }

    // Remove expired
    // Find Objects with Date Greater Than N Days
    const indexes = findExpiredObjects(recentBlogsArray, currentDate, expiryDays);
    console.log('indexes of expired objects:', indexes); // This will log indexes of objects with seenDates more than 30 days in the past

    // Manage expired
    batchRemoveByIndexes(indexes, recentBlogsArray);
    // removeFromArray(recentBlogsArray, siteCode, 'tdu');



    // check current URL isn't in currentArray
    const foundIndex = findIndexByProperty(recentBlogsArray, 'url', pageUrl);
    console.log('Existing url foundIndex:', foundIndex);

    // remove if current URL is in currentArray
    batchRemoveByIndexes(foundIndex, recentBlogsArray);


    // console.log('recentBlogsArray AA:::', recentBlogsArray);
    // add current URL's data onto currentArray
    recentBlogsArray.push(blogObject);
    console.log('recentBlogsArray BB:::', recentBlogsArray);


    // sort currentArray by seenDate
    sortByseenDate(recentBlogsArray)

    //Prevent more than 5 items in array
    // Count
    const count = countBlogs(recentBlogsArray);
    if (count > 5) {
      recentBlogsArray.shift(); // remove oldest (first) blog
    }

    // Set to Storage
    setStoredBlogsTo(siteCode, recentBlogsArray);


    console.log('recentBlogsArray:::', recentBlogsArray);


    // const foundObject = findObjectByProperty(recentBlogsArray, 'url', pageUrl);
    // console.log('foundObject:', foundObject);


    // Use page URL as unique ID.
    // Add to store when Blog Post is viewed(page hit).

    super.load();

  }
}



// Set blogs to localStorage
function setStoredBlogsTo(siteCode, recentBlogsArray) {
  localStorage.setItem('recentBlogs-' + siteCode, JSON.stringify(recentBlogsArray));
  // console.log('Saved recent blogs to localStorage.');
}


// Remove batch from Array
function batchRemoveByIndexes(indexes, recentBlogsArray) {
  // Sort indexes in descending order to avoid index shifting issues
  const sortedIndexes = indexes.sort((a, b) => b - a);

  // Remove items from recentBlogsArray at the specified indexes
  sortedIndexes.forEach(index => {
    if (index >= 0 && index < recentBlogsArray.length) {
      recentBlogsArray.splice(index, 1);
    }
  });

  return recentBlogsArray;
}


// Remove from Array
// function removeFromArray(array, itemIndex) {
//   const index = array.indexOf(itemIndex);
//   if (index > -1) { // only splice array when item is found
//     array.splice(index, 1); // 2nd parameter means remove one item only
//     console.log('object removed from Array');
//   }
// }


// Count blogs
function countBlogs(recentBlogsArray) {
  const count = recentBlogsArray.length;
  console.log('count:', count);
  return count;
}


//Find item in array
function findObjectByProperty(array, property, value) {
  return array.find(item => item[property] === value);
}


//Find index of item in array
function findIndexByProperty(array, property, value) {
  return array
    .map((item, index) => item[property] === value ? index : -1) // Map to index or -1
    .filter(index => index !== -1); // Filter out non-matches
  // return array.findIndex(item => item[property] === value);
}


// Manage expired
// A JavaScript function, that if objects in the array have a property of
// seenDate with values formatted as yyyy - mm - dd such as 2004-01-21.
// Return the index of each item that has an seenDate greater than
// 30days in the past from a supplied currentDate.
function findExpiredObjects(array, currentDate_ms, expiryDays) {

  if (currentDate_ms.length < 10) {
    console.warn('currentDate_ms is not formatted correctly.');
    return;
  }
  // console.log('currentDate_ms: ', new Date(currentDate_ms));

  const currentDateObj = new Date(currentDate_ms);
  console.log('currentDate as Human: ', currentDateObj);

  // Calculate the threshold date, which is {expiryDays} in the past from the currentDate.
  const thresholdDate = currentDateObj - (expiryDays * 24 * 60 * 60 * 1000); // days * 24h * 60m * 60s * 1000ms
  console.log('thresholdDate as Human: ', new Date(thresholdDate));

  // console.log('array: ', array);

  // Use filter to find all indexes where seenDate is greater than 30 days in the past
  return array
    .flatMap((item, index) => {
      // Convert seenDate string to a Date object
      const seenDateObj = new Date(item.seenDate);

      // Check if seenDate is older than thresholdDate. (Newer dates will be greater than older ones).
      if (seenDateObj < thresholdDate) {
        return index; // Return index if condition is true
      } else {
        return []; // Return empty array if condition is false, which will be flattened away
      }
    });
}


function isBlogsArrayValid(array) {
  // console.log('isBlogsArrayValid');
  // console.log('BlogsArray: ', array);
  // console.log('BlogsArray length: ', array.length);

  if (array.length === undefined || !array.length > 0) {
    console.warn('Invalid array. Deleting: ', array);
    return false; // empty array
  }

  return true;
}

// sort array by date
function sortByseenDate(array) {
  return array.sort((a, b) => {
    // Convert seenDate strings to numbers for comparison
    const dateA = Number(a.seenDate);
    const dateB = Number(b.seenDate);

    return dateA - dateB;
  });
}


// create Fragment
function createFragment(array) {

  const recentEls = document.querySelectorAll('.recentblogviews-section');

  // Check if element exists
  if (recentEls.length < 1) {
    console.log('no RecentBlogViews module on page.');
    return;
  }

  // TODO:
  // image alt text (Not Title, will need to capture it to localStorage)
  // as much Bootstrap styling as possible

  let itemsChunk = '';

  for (const item in array.reverse()) {
    if (Object.hasOwnProperty.call(array, item)) {
      const title = array[item].title;
      const imageSmall = resizeImage(array[item].image, 'small');
      const imageLarge = resizeImage(array[item].image, 'large');
      const pageUrl = array[item].url;
      const seenDate = array[item].seenDateHuman;
      const domain = window.location.origin;
      const placeholder = `${domain}/static/images/3x2grey.gif`;

      // d-flex flex-column
      itemsChunk = itemsChunk + `
        <li class="recentblog textVisible slide-visible">
          <a href="${pageUrl}" target="_blank" data-date="${seenDate}"
            class="recentblog__link  card align-content-stretch">
              <img class="recentblog__image lazy card-img-top"
                width="540" height="350"
                data-srcset="${imageLarge} 540w, ${imageSmall} 300w"
                sizes="(max-width: 992px) 540px, 300px"
                src="${placeholder}"
                alt="${title}">
              <div class="recentblog__caption card-body">
                  <span class="recentblog__title card-title">${title}</span>
              </div>
          </a>
        </li>
        `;
    }
  }


  const HTMLchunk = `
    <style>
    .recentblog__image{height: fit-content;}
    </style>
    <div class="recentblogviews__container container recentblogviews--swiffy-settings swiffy-slider indicatorsFalse slider-item-show4 slider-item-nogap slider-indicators-outside slider-indicators-round slider-indicators-dark slider-nav-page slider-nav-round slider-nav-animation slider-nav-animation-fadein slider-item-first-visible">

      <ul class="recentblogviews__list slider-container">
          ${itemsChunk}
      </ul>

      <button type="button" class="slider-nav slider-nav-prev" aria-label="previous slide"></button>
            <button type="button" class="slider-nav slider-nav-next" aria-label="next slide"></button>

      <div class="slider-indicators">
        <button class="active" aria-label="active slide"></button>
        <button></button>
        <button></button>
      </div>

    </div>
  `;
  const wrapperNode = document.createElement('div');
  wrapperNode.innerHTML = HTMLchunk;

  const firstRecentEl = recentEls[0];
  // append to DOM
  firstRecentEl.append(wrapperNode);
  console.log('recentblogviews Fragment added to DOM');

  global.swiffyslider = swiffyslider;  // add swiffyslider function to the global/window object
  global.swiffyslider.init();          // start swiffyslider
  console.log('init swiffyslider: ');

}


function resizeImage(imagePath, size) {
  const matchStr = '?w=1100&width=1100';
  const smallStr = '?width=300&height=188&mode=crop'
  const defaultStr = '?width=576&height=360&mode=crop';
  const newStr = (size === 'small') ? smallStr : defaultStr;
  const newPath = imagePath.split(matchStr)[0] + newStr;
  // if (imagePath.length > 0 && imagePath.includes(matchStr)) {
  //   //
  //   console.log('does contain substring.');

  // }
  console.log('newPath: ', newPath);

  return newPath;
}
